import React, { createContext, Dispatch, useContext, useReducer } from "react";
import { RecentActivities, RecentInsights } from "./WasteManagementContext";
import {
  AgriChartData,
  AgriChartDataResp,
  BinOverviewReportCard,
  GetInfraDetectionTrendData,
  InfraChartData,
  InfraGraphData,
  InfraReportData,
  ProcessedAgriChartData,
  ProcessedDetectionChartData,
  RetailFreshnessData,
  TotalDeviceCount,
} from "../Models/Models";
import { SnapViewInfo } from "../Models/Models";

export interface AgricultureType {
  hasChartData: boolean;
  groupId: string;
  type: string;
  siteCode: string;
  infraGraphData: InfraGraphData[];
  infraGraphDuration: string;
  agriGrowthChartData: InfraChartData[];
  AgriChartData: AgriChartData[];
  agriGrowthGraphData: InfraChartData[];
  AgriChartDataResp: AgriChartDataResp[];
  ProcessedDetectionChartData: ProcessedDetectionChartData[];
  ProcessedAgriChartData: ProcessedAgriChartData[];
  infraChartDuration: string;
  tooltipChange: number;
  tooltipValue: number;
  infrachartStartIndex: number;
  TotalDeviceCount: TotalDeviceCount[];
  snapViewInfo: SnapViewInfo[];
  fromDate: string;
  dates: string[];
  modalOpen: boolean;
  currentDateIndex: number;
  infraDetectionDuration: string;
  label: string;
  selectedAgriLables: string;
  agriLabels: string[];
  loader:boolean;
  agriReportData: InfraReportData[];
  totalWasteMoniterValue: number;
  totalWasteValueChanges: string;
  totalWasteValueColor: string;
  averageFillWastelabel: number;
  avgWasteValueChanges: string;
  avgWasteValueColor: string;
  pageNo: number;
  pageSize: number;
  totalElements: number;
}

const initialState: AgricultureType = {
  hasChartData: false,
  groupId: "",
  type: "",
  siteCode: "",
  loader:false,
  infraGraphData: [] as InfraGraphData[],
  infraGraphDuration: "Last 6 months",
  agriGrowthChartData: [] as InfraChartData[],
  AgriChartData: [] as AgriChartData[],
  agriGrowthGraphData: [] as InfraChartData[],
  infraChartDuration: "months",
  infraDetectionDuration: "Monthly",
  tooltipChange: 0,
  tooltipValue: 0,
  infrachartStartIndex: 0,
  TotalDeviceCount: [] as TotalDeviceCount[],
  AgriChartDataResp: [] as AgriChartDataResp[],
  ProcessedDetectionChartData: [] as ProcessedDetectionChartData[],
  ProcessedAgriChartData: [] as ProcessedAgriChartData[],
  snapViewInfo: [],
  fromDate: "",
  dates: [],
  modalOpen: false,
  label: "",
  currentDateIndex: 0,
  selectedAgriLables: "",
  agriLabels: [],
  agriReportData: [] as InfraReportData[],
  totalWasteMoniterValue: 0,
  totalWasteValueChanges: "",
  totalWasteValueColor: "",
  averageFillWastelabel: 0,
  avgWasteValueChanges: "",
  avgWasteValueColor: "",
  pageNo: 0,
  pageSize: 10,
  totalElements: 0,
};

type ActionType =
  | {
      field: keyof AgricultureType;
      type: "SET_FIELD";
      value:
        | string
        | string[]
        | boolean
        | number
        | HTMLElement
        | BinOverviewReportCard[]
        | RecentActivities[]
        | RecentInsights[]
        | InfraGraphData[]
        | InfraChartData[]
        | TotalDeviceCount[]
        | AgriChartDataResp[]
        | ProcessedDetectionChartData[]
        | ProcessedAgriChartData[]
        | AgriChartData[]
        | SnapViewInfo[]
        | undefined
        | null;
    }
  | {
      type: "BULK_UPDATE";
      value: Partial<AgricultureType>;
    }
  | {
      type: "RESET";
    }
  | {
      type: "SET_HAS_CHART_DATA";
      value: boolean;
    };

const reducer = (
  state: AgricultureType,
  action: ActionType
): AgricultureType => {
  switch (action.type) {
    case "SET_FIELD":
      return { ...state, [action.field]: action.value };
    case "BULK_UPDATE":
      return { ...state, ...action.value };
    case "RESET":
      return { ...initialState };
    default:
      return state;
  }
};

const AgricultureProvider = createContext<{
  agricultureState: AgricultureType;
  dispatchAgriculture: Dispatch<ActionType>;
}>({
  agricultureState: initialState,
  dispatchAgriculture: () => null,
});

type ContextProviderProps = {
  children: React.ReactNode;
};

const AgricultureContext = ({ children }: ContextProviderProps) => {
  const [agricultureState, dispatchAgriculture] = useReducer(
    reducer,
    initialState
  );

  return (
    <AgricultureProvider.Provider
      value={{ agricultureState, dispatchAgriculture }}
    >
      {children}
    </AgricultureProvider.Provider>
  );
};

const useAgriculture = () => {
  return useContext(AgricultureProvider);
};

export { AgricultureContext, useAgriculture };
